import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import theme from './config/theme';
import StoreProvider from './config/store';
import LoaderProvider from './config/loader';
import App from './App';
import { AUTH_USER, UNAUTH_USER } from './actions/types';

const applicationStoreStartup = (store) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (token) {
    store.dispatch({
      type: AUTH_USER,
      payload: role,
    });
  } else {
    store.dispatch({ type: UNAUTH_USER });
  }
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Target container is not a DOM element');
  throw new Error('Target container is not a DOM element');
}

const root = createRoot(rootElement);

root.render(
  <ThemeProvider theme={theme}>
    <StoreProvider onStartup={applicationStoreStartup}>
      <LoaderProvider>
        <App />
      </LoaderProvider>
    </StoreProvider>
  </ThemeProvider>
);
